module.exports = __webpack_public_path__ + "img/position_WM.bed48448.png";